export default class Float {
    public static floatToIntBits(f: number): number {
        return f;
    }
}
